import React from 'react';
import './form.scss';
import { TIcon } from '../icon/icon.model';
import { Icon } from '../icon';

type FormProps = {
  children: any;
  className?: string;
};

export const Form = (props: FormProps) => {
  const { children, className } = props;

  return <div className={`form ${className || ''}`}>{children}</div>;
};

type FormGroupProps = {
  children: any;
};

export const FormGroup = (props: FormGroupProps) => {
  const { children } = props;

  return <div className="form-group">{children}</div>;
};

type FormGroupTitleProps = {
  title: string;
  children?: any;
};

export const FormGroupTitle = (props: FormGroupTitleProps) => {
  const { title, children } = props;
  return (
    <div className="d-flex align-items-center  mb-3">
      <h2 className="heading h-12">{title}</h2>
      {children}
    </div>
  );
};

type FormItemProps = {
  children: any;
  label?: string;
  htmlFor?: string;
  className?: string;
  icon?: TIcon;
  style?: React.CSSProperties;
};

export const FormItem = (props: FormItemProps) => {
  const { children, label, htmlFor, className, icon, style } = props;

  return (
    <div className={`form-item ${className || ''}  `} style={style}>
      {label && <label htmlFor={htmlFor}> {label} </label>}
      <div className={`form-item-content  ${icon ? 'hasIcon' : ''}`}>
        {icon && (
          <div className="form-item-icon">
            <Icon content={icon} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

type FormErrorProps = {
  error: any;
  validation?: any;
};

export const FormError = (props: FormErrorProps) => {
  const { error, validation } = props;

  if (!error) {
    return null;
  }

  let message;

  const custom = {
    match: validation?.match?.message,
    value: validation?.type?.value?.message,
  };

  if (error.type !== undefined && error.type in custom) {
    message = custom[error.type];
  } else if (error.match !== undefined && error.match in custom) {
    message = custom[error.match];
  } else {
    message = error?.message;
  }

  return message && <div className="form-error">{message} </div>;
};

type FormRowProps = {
  className?: string;
  children: any;
  col?: string;
};

export const FormRow = (props: FormRowProps) => {
  const { children, col, className } = props;

  return <div className={`form-row ${className || ''} ${col ? `cols-${col}` : ''}`}>{children}</div>;
};

type TReadOnly = {
  content: any;
  className?: string;
};

export const ReadOnly = (props: TReadOnly) => {
  const { content, className } = props;
  return <div className={`readOnly ${className || ''}`}>{content || '-'}</div>;
};

type FloatingLabelProps = {
  content: string;
  htmlFor: string;
  className?: string;
};

export const FloatingLabel = (props: FloatingLabelProps) => {
  const { content, className, htmlFor } = props;
  return (
    <label htmlFor={htmlFor} className={`floating-label ${className || ''}`}>
      {content}
    </label>
  );
};

type FormPasswordToggleProps = {
  visible: boolean;
  toggle: (key: any) => void;
  className?: string;
};

export const FormPasswordToggle = (props: FormPasswordToggleProps) => {
  const { visible, toggle, className } = props;

  return (
    <div className={`form-password-toggle ${className || ''}`} onClick={toggle}>
      {visible ? <Icon size="smd" content="viewOff" /> : <Icon size="smd" content="view" />}
    </div>
  );
};

type FieldWithIconProps = {
  icon: TIcon;
  children: any;
  className?: string;
};

export const FieldWithIcon = (props: FieldWithIconProps) => {
  const { icon, children, className } = props;

  return (
    <div className={`field-with-icon-container ${className || ''}`}>
      <div className={`field-with-icon-icon ${className || ''}`}>
        <Icon size="md" content={icon} />
      </div>
      <div className="field-with-icon-content">{children}</div>
    </div>
  );
};
